import React from 'react';


export default function CartColumns() {
  return (
    <div className="cartColContainer">
      <div className="cartRow">
        <div className="cartCol">
          <p id="cartProducts">Products</p>
        </div>
        <div className="cartCol">
          <p id="cartProducts">Name of Product</p>
        </div>
        <div className="cartCol">
          <p id="cartProducts">Price</p>
        </div>
        <div className="cartCol">
          <p id="cartProducts">Quantity</p>
        </div>
        <div className="cartCol">
          <p id="cartProducts">Remove</p>
        </div>
        <div className="cartCol">
          <p id="cartProducts">Total</p>
        </div>
      </div>
    </div>
  )
}
